export default __webpack_public_path__ + "static/media/upload.bfb23cc9.svg";